/* Coco y Mimos — label behaviour. Content is complete without this file. */
(function () {
  if (window.__cymReady) return; window.__cymReady = true;
  var root = document.documentElement;
  root.classList.add('cym-js');

  /* ---- ETA: comuna on the despacho label ---- */
  var HOLIDAYS = ['2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25', '2027-01-01'];
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function chileNow() {
    var s = new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' });
    return new Date(s);
  }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function isWorkday(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function addWorkdays(start, n) {
    var d = new Date(start);
    var left = n;
    while (left > 0) { d.setDate(d.getDate() + 1); if (isWorkday(d)) left--; }
    return d;
  }
  function label(d, withMonth) { return DAYS[d.getDay()] + ' ' + d.getDate() + (withMonth ? ' de ' + MONTHS[d.getMonth()] : ''); }

  function eta(zone) {
    var now = chileNow();
    var ship = new Date(now);
    if (now.getHours() >= 14 || !isWorkday(now)) { ship = addWorkdays(now, 1); }
    var range = zone === 'rm' ? [1, 3] : [3, 7];
    var a = addWorkdays(ship, range[0]);
    var b = addWorkdays(ship, range[1]);
    var sameMonth = a.getMonth() === b.getMonth();
    return 'entre el ' + label(a, !sameMonth) + ' y el ' + label(b, true);
  }

  document.querySelectorAll('[data-comuna]').forEach(function (select) {
    var out = select.closest('[data-route]').querySelector('[data-eta]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function update(animate) {
      var zone = select.selectedOptions[0].getAttribute('data-zone');
      var text = eta(zone);
      if (!animate || reduce) { out.textContent = text; return; }
      out.classList.add('is-changing');
      setTimeout(function () { out.textContent = text; out.classList.remove('is-changing'); }, 180);
      try { localStorage.setItem('cym-comuna', select.value); } catch (e) {}
    }
    try { var saved = localStorage.getItem('cym-comuna'); if (saved) select.value = saved; } catch (e) {}
    update(false);
    select.addEventListener('change', function () { update(true); });
  });

  /* ---- Variant tabs on the showcase ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var input = document.querySelector(group.getAttribute('data-tabs'));
    group.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        if (input) input.value = btn.getAttribute('data-variant');
        var img = document.querySelector(group.getAttribute('data-img'));
        var src = btn.getAttribute('data-src');
        if (img && src) img.src = src;
      });
    });
  });

  /* ---- Add to cart: busy state while the form posts ---- */
  document.querySelectorAll('form[data-cym-cart]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var b = form.querySelector('button[type="submit"]');
      if (b) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Agregando…'; }
    });
  });

  /* ---- Entrances: heading, then text, then picture; once ---- */
  var groups = document.querySelectorAll('[data-rise]');
  if (!('IntersectionObserver' in window)) return;
  groups.forEach(function (g) {
    g.querySelectorAll('.cym-rise').forEach(function (el, i) { el.style.setProperty('--i', i); });
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('.cym-rise').forEach(function (el) { el.classList.add('is-in'); });
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  groups.forEach(function (g) { io.observe(g); });
})();
